(ns web3.backend-stubs
  (:require [clojure.string :as str]))

;; namespace for stuff that should probably be handled by the backend,
;; but can work with temporary/hacky client-side implementations.
;; Tracks with centriq-mobile.redesign.resolvers on mobile
;; https://github.com/centriqtechnology/centriq-mobile/blob/develop/src/centriq_mobile/redesign/resolvers.cljs#L6


(def group-aliases
  (->> {	["automobile"
           "automotive"
           "car"
           "auto"
           "vehicle"
           "truck"
           "jeep"
           "subaru"
           "sonata"
           "honda"
           "transportation"
           "carseat"
           "cars & garage"] :group/cars
        ["travel trailer"] :group/camper
        ["bedroom"
         "bed room"
         "bedroom2"
         "boys room"
         "master suite"
         "suite"
         "guestroom"
         "guest room"
         "master"
         "masterbedroom"
         "master bed"
         "master bedroom"
         "master br"
         "mbr"
         "master bed/bath"
         "master bedroom/bath"
         "master bed/bathroom"
         "downstairs bedroom"
         "basement bedroom"
         "my room"
         "kids room"
         "spare room"
         "girls room"
         "master bedroom/bathroom"
         "kids stuff"
         "guest bed"
         "guest br"
         "bedroom-master"
         "upstairs bedrooms"
         "bdrm"
         "nicks room"
         "paul's room"
         "small guest room"
         "guest suite"
         "master bdr"
         "bdr"
         "br1"
         "bedroom 1"
         "master room"
         "basement guest room"
         "futon room"] :group/bedroom
        ["finishes"
         "carpet"
         "decor"
         "tile"
         "door knob"
         "construction"
         "decoration"
         "roofing"
         "shutter"
         "window"
         "doors and windows"
         "windows & doors"
         "material"
         "screen"
         "window treatment"
         "foundation"] :group/building-finishes
        ["consumable"
         "supply"
         "supplies"] :group/consumables
        ["lighting"
         "light"
         "light fixture"
         "light bulb"
         "lightbulb"
         "bulb"
         "outdoor lighting"
         "lamp"
         "outside light"] :group/lights
        ["flooring"
         "floor"] :group/flooring
        ["electronic"
         "gadget"
         "eletronic"
         "elecronic"
         "electronica"
         "computer"
         "computers/printers"
         "computers/phones"
         "technology"
         "laptop"
         "tech"
         "media"
         "internet"
         "printer"
         "device"
         "apple"
         "network"
         "gear"
         "intercom"
         "batteries"
         "battery"
         "mobile"
         "portable"
         "server"
         "router"
         "communication"
         "entertainment electronic"
         "entertainment device"
         "office electronic"
         "computer/network"
         "computer/electronic"
         "wifi"
         "wi fi"] :group/electronics
        ["car electronic"] :group/car-electronics
        ["audio"
         "radio"
         "speaker"
         "sound system"] :group/audio
        ["phone"
         "cell phone"
         "iphone"
         "android"] :group/phone
        ["everything else"
         "misc"
         "misc."
         "miscellaneous"
         "other"
         "general"
         "stuff"
         "household item"
         "purchase"
         "items purchased"
         "home general"
         "new"
         "home stuff"
         "miscellaneous item"
         "item"
         "misc. item"
         "various"
         "extras"] :group/everything-else
        ["garage"
         "garage/shed"
         "tool room"
         "garage/outdoor"
         "garage/tool"
         "garage/shop"
         "shop"
         "workshop"
         "work shop"
         "woodshop"
         "wood shop"
         "shed"
         "barn"
         "carport"
         "driveway"
         "garage/yard"
         "garage/basement"
         "garage/lawn"
         "garage/outside"
         "carriage house"
         "parking pad"
         "garage/barn"] :group/garage
        ["kitchen"
         "kiitchen"
         "kitcken"
         "kitchen/dining"
         "home kitchen"
         "home - kitchen"
         "main house kitchen"
         "outdoor kitchen"
         "upstairs kitchen"
         "downstairs kitchen"
         "basement kitchen"
         "kitchen basement"
         "kitchen - basement"
         "pantry"
         "grill"
         "kitchenette"
         "cocina"
         "cuisine"
         "kitchen faucet"
         "outdoor cooking"
         "kit"
         "kitchen/dining room"] :group/kitchen
        ["living"
         "family room"
         "family"
         "den"
         "livingroom"
         "great room"
         "sitting room"
         "basement living room"
         "downstairs living room"
         "upstairs living room"
         "lower living room"
         "lounge"
         "living/dining room"
         "parlor"
         "living room/dining room"
         "living room / dining room"
         "living/dining"
         "familyroom"
         "cuarto principal"
         "parlour"
         "greatroom"
         "main room"
         "living room/den"
         "keeping room"] :group/living-room
        ["laundry"
         "laundry closet"
         "washer and dryer"
         "washer/dryer"
         "dryer"
         "laundry/utilities"
         "laundry room basement"
         "laundry/utility"
         "lower level laundry"
         "downstairs laundry"
         "washer"
         "washing machine"] :group/laundry
        ["major appliance"
         "applaince"
         "appliance"
         "general appliance"
         "household appliance"
         "dishwasher"
         "range"
         "basement appliance"
         "house appliance"
         "refrigerator"
         "fridge"
         "frig"
         "kitchen appliances"
         "oven"] :group/major-appliances
        ["mechanical"
         "mechanical room"
         "hvac"
         "hvc"
         "utility"
         "utilities"
         "utilites"
         "furnace room"
         "furnace"
         "water heater"
         "air conditioner"
         "ac"
         "a/c"
         "ac unit"
         "systems"
         "heating"
         "heater"
         "heating/ac"
         "boiler room"
         "building system"
         "home system"
         "generator"
         "air conditioning"
         "heating and cooling"
         "heating/cooling"
         "heating & cooling"
         "boiler"
         "air filter"
         "house system"
         "filter"
         "thermostat"
         "air"
         "central air"
         "heat pump"
         "basement utility room"
         "infrastructure"
         "basement utilities"
         "household system"
         "basement mechanical"
         "laundry/utility room"
         "mep"
         "furance"
         "nest"
         "honeywell"
         "ecobee"
         "mech room"
         "basement utility"
         "home mep"
         "ac filters"
         "mechanic"
         "ac/furnace"
         "equipment room"
         "utilities room"
         "humidifier"
         "hot water tank"
         "heating/hot water"
         "propane"
         "machine"
         "water heater/hvac"
         "furnance"
         "hot water"
         "major system"] :group/mechanical
        ["office"
         "basement office"
         "study"
         "work"
         "workroom"
         "work room"
         "downstairs office"
         "office/bedroom"
         "office appliance"
         "bureau"
         "basement/office"
         "studio/office"
         "office bedroom"] :group/office
        ["personal"
         "personal item"
         "jewelry"
         "ring"
         "jewerly"
         "personel"
         "home item"
         "hair product"] :group/personal-items
        ["personal inventory"
         "misc items"
         "accessories"
         "my stuff"
         "assorted"
         "inventory"] :group/personal-inventory
        ["pool"
         "hot tub"
         "pool/spa"
         "pool house"] :group/pool
        ["pet"
         "dog"
         "cat"
         "animal"
         "frog"
         "hamster"
         "parrot"
         "ferret"
         "gerbil"
         "guinea pig"
         "turtle"
         "tortoise"
         "fish"
         "rabbit"
         "bird"] :group/pets
        ["plant"
         "tree"
         "outside"
         "outdoor"
         "yard"
         "backyard"
         "back yard"
         "garden"
         "lawn"
         "landscaping"
         "landscape"
         "irrigation"
         "sprinkler"
         "greenhouse"
         "front"
         "lawncare"
         "yard/garden"
         "landscape light"
         "pruning schedule"] :group/plants-trees
        ["sample group"
         "sample"
         "example"
         "test"
         "samples"
         "centriq tips"
         "homeserve"
         "homeserve tips"] :group/sample-group
        ["small appliance"
         "other appliance"
         "microwave"
         "misc appliance"
         "small kitchen appliance"
         "kitchen small appliance"
         "coffee maker"
         "appliances-small"] :group/small-appliances
        ["power tool"
         "powertool"
         "power equipment"
         "tools and equipment"
         "tool"
         "maintenance"
         "woodworking"
         "ryobi"
         "dewalt"
         "skil"
         "black-decker"
         "black and decker"
         "black & decker"
         "black&decker"
         "black+decker"
         "milwaukee"
         "makita"
         "bosch"
         "stihl"
         "repair"
         "shop equipment"
         "workshop tool"
         "home improvement"
         "air tool"
         "drill"
         "work bench"
         "household tool"
         "tools/hardware"
         "equipment"
         "garage tool"
         "hardware"
         "house maintenance"
         "remodel"
         "home maintenance"] :group/power-tools
        ["bathroom"
         "bathroom master"
         "bathroom downstairs"
         "kid's bathroom"
         "bath room"
         "master bath"
         "masterbath"
         "bath"
         "basement bathroom"
         "basement bath"
         "downstairs bathroom"
         "downstairs bath"
         "hall bath"
         "bathroom/laundry"
         "water room"
         "kitchen bathroom"
         "upstairs guest bathroom"] :group/bathroom
        ["countertop"] :group/countertops
        ["paint"
         "exterior paint color"
         "painting"] :group/paint
        ["basement"
         "basment"
         "basement/laundry"
         "basement and laundry"
         "basement workshop"
         "downstairs"
         "cellar"
         "cellar/laundry"
         "crawl space"
         "crawlspace"] :group/basement
        ["rv"
         "recreational vehicle"
         "motorhome"
         "motor home"] :group/rv
        ["bicycle"
         "bike"] :group/bicycles
        ["motorcycle"
         "motorbike"
         "moped"] :group/motorcycles
        ["boat"] :group/boats
        ["jetski"
         "jet ski"] :group/jetskis
        ["powder"
         "powder room"
         "half bath"
         "washroom"
         "wash room"
         "water closet"
         "wc"
         "1/2 bath"] :group/half-bathroom
        ["entertainment center"
         "entertainment"
         "tv"
         "tv's"
         "television"
         "tv room"
         "media room"
         "theater"
         "theatre"
         "movie room"
         "home entertainment"
         "home theater"
         "basement tv room"
         "entertainment system"
         "home theater room"
         "audio visual"
         "audio video"
         "av"
         "av equipment"
         "a/v"
         "audio/visual"
         "audio / video"
         "audio & video"
         "stereo"
         "audio / visual"
         "audio/video"
         "audio-video"
         "a/v equipment"
         "tv audio"
         "sonos"
         "airplay"
         "audio equipment"
         "video"] :group/entertainment-center
        ["outdoor tool"
         "outside tool"
         "yard tool"
         "lawn tool"
         "outdoor appliance"
         "lawn equipment"
         "lawn and garden equipment"
         "yard equipment"
         "outdoor equipment"
         "outdoor power equipment"
         "snowblower"
         "garden tool"
         "gardening"
         "garden equipment"
         "lawn mower"
         "lawn & garden equipment"
         "snow blower"
         "lawnmower"
         "yard machines"
         "outside work"
         "outdoor power tool"
         "lawn equiptment"
         "outdoor equip"
         "leaf blower"
         "lawn care equipment"
         "lawn tractor"
         "house equipment"] :group/outdoor-tools
        ["sports equipment"
         "gym"
         "exercise"
         "workout"
         "sporting good"
         "sport"
         "fitnes"
         "excercise"
         "sporting"] :group/sports-equipment
        ["cleaning equipment"
         "cleaning"
         "cleaning machine"
         "vacuum"
         "cleaning appliance"
         "cleaning supply"
         "cleaning supplies"
         "housekeeping"
         "cleaner"
         "cleaning closet"
         "vaccum"
         "household cleaning"
         "house hold item"] :group/cleaning-equipment
        ["nursery"
         "baby"
         "baby stuff"
         "babies"
         "baby's"] :group/nursery
        ["play room"
         "playroom"
         "toy"
         "kid"] :group/play-room
        ["bar"
         "basement bar"
         "outdoor bar"
         "downstairs bar"] :group/bar
        ["foyer"
         "foyer/hallway"
         "front room"
         "mud room"
         "mudroom"
         "entry"
         "entryway"
         "front door"
         "front entry"
         "hallway"
         "hall"
         "upstairs hall"
         "upstairs hallway"
         "front hall"
         "back hall"
         "entry hall"
         "hallways"
         "entrance"
         "breezeway"
         "hall way"] :group/foyer
        ["dining room"
         "diningroom"
         "breakfast nook"
         "dining"
         "breakfast room"
         "breakfast area"
         "dining/living"
         "coffee room"] :group/dining-room
        ["exterior"
         "house"
         "home"
         "guest house"
         "general household"
         "general house"
         "house stuff"
         "property"
         "general house info"
         "our home"
         "building"
         "whole house"
         "home health"
         "household"] :group/exterior
        ["closet"
         "master bedroom closet"] :group/closet
        ["music instrument"
         "musical instrument"
         "instrument"
         "music"
         "music room"
         "guitar"
         "piano"
         "band equipment"] :group/musical-instruments
        ["safe"] :group/safe
        ["fire alarm"
         "alarm"
         "smoke alarm"
         "detector"
         "fire safety"
         "emergency shutoff"] :group/fire-alarms
        ["holiday decoration"
         "holiday"
         "christmas"
         "xmas"
         "x-mas"] :group/holiday-decorations
        ["sewer"
         "septic"
         "septic tank"
         "sump"
         "pump house"] :group/sewer
        ["medical"
         "medicine"
         "meds"
         "healthcare"] :group/medical
        ["electrical"
         "electric"
         "electrial"] :group/electrical
        ["furniture"
         "furnature"
         "furnishings"] :group/furniture
        ["files"
         "documents"] :group/files
        ["hobby"
         "drawing room"
         "craft"
         "project"
         "arts & craft"
         "arts and craft"
         "arts/craft"] :group/crafts
        ["art"
         "artwork"] :group/art
        ["sew"
         "sewing"
         "sewing room"
         "sewing/computer room"
         "office/sewing room"] :group/sewing
        ["clothing"
         "shoes"
         "clothes"] :group/clothing
        ["water"
         "well house"
         "fluids"
         "water treatment"
         "water system"
         "plumbing"] :group/water
        ["weapon"
         "gun"
         "firearm"
         "shooting"
         "armory"
         "hunting"] :group/weapons
        ["nick"] :group/nick
        ["library"
         "book"] :group/books
        ["deck"
         "patio"
         "porch"
         "garden furniture"
         "outdoor item"
         "outdoor stuff"] :group/patio
        ["atv"] :group/atv
        ["sunroom"
         "florida room"
         "morning room"
         "florida house"
         "solar"] :group/sun-room
        ["loft"
         "unit"
         "condo"
         "apartment"
         "appartment"
         "apt"
         "first floor"
         "1st floor"
         "main floor"
         "rent"
         "rental"
         "airbnb"
         "vrbo"
         "homeaway"
         "duplex"
         "hoa"] :group/unit
        ["roof"
         "attic"
         "upstairs"
         "stairwell"
         "up stairs"
         "upstairs landing"] :group/attic
        ["bonus room"
         "interior"
         "flex room"
         "west wing"
         "blue room"
         "lake room"
         "gold room"
         "scrapbook room"
         "other rooms"
         "room"
         "door"
         "studio"] :group/bonus-room
        ["game room"
         "game"
         "rec room"
         "recreation room"] :group/game-room
        ["man cave"
         "cave"
         "man room"
         "mancave"
         "man-cave"] :group/man-cave
        ["smart home"
         "home automation"
         "smart house"
         "smart thing"
         "automation"] :group/smart-home
        ["safety"
         "health"
         "emergency info"
         "medical device"
         "hearing aid"
         "emergency"] :group/safety
        ["fireplace"
         "fireplace room"] :group/fireplace
        ["cabin"
         "lake home"
         "lake house"
         "casita"
         "cottage"] :group/cabin
        ["insurance"
         "warranties"
         "warranty"
         "home warranty"] :group/insurance
        ["manual"
         "docs"
         "house document"
         "household information"
         "home doc"
         "home info"
         "house info"
         "information"
         "important information"
         "important doc"] :group/manuals
        ["taxes"
         "tax"
         "banking"
         "donation"
         "estimate"
         "loan"] :group/taxes
        ["reciept"
         "receipt"
         "expense"] :group/receipts
        ["house plan"
         "measurement"
         "floor plan"
         "addition"
         "demolition"] :group/house-plans
        ["recreation"
         "outdoor gear"
         "retreat"
         "camping"
         "camp"
         "outdoor living"
         "recreational"] :group/recreation
        ["camera"
         "photo"
         "photography"
         "photo equipment"
         "camera equipment"
         "house photo"
         "picture"] :group/photos
        ["wine"
         "wine cellar"] :group/wine
        ["service"] :group/services
        ["tractor"
         "farm equipment"
         "kubota"
         "farm"] :group/tractor
        ["pond"
         "lake"
         "fountain"] :group/pond
        ["lock"
         "door lock"
         "safety & security"
         "home security"
         "security"
         "password"] :group/lock
        ["balcony"] :group/balcony
        ["travel"] :group/travel
        ["ski room"
         "winterize"
         "winter"
         "cold"] :group/winter
        ["store"
         "store room"
         "storage"] :group/store
        ["boat house"
         "dock"
         "boat shed"] :group/boat-house
        ["gate"
         "fence project"
         "front gate"
         "fence"] :group/gate
        ["sauna"
         "spa"] :group/sauna
        ["handicap"
         "handicapped"] :group/handicap
        ["clock"] :group/clocks
        ["aquarium"
         "fishing equipment"
         "fishing"] :group/aquarium
        ["pest control"
         "pest"] :group/pest-control
        ["seasonal"] :group/seasonal
        ["bestbuy"
         "best buy"
         "bby"] :group/brand-bestbuy}
       (reduce-kv
        (fn [out patterns v]
          (reduce (fn [out pattern-str]
                    (conj out [pattern-str v]))
                  out patterns))
        [])
       (sort-by (comp count first))
       (reverse)
       (mapv (fn [[pattern-str v]]
               [(re-pattern (str "\\b" (str/escape pattern-str {\+ "\\+"}) "s?\\b")) v]))))

(def name->group
  (memoize
   (comp
    (fn [name]
      (first (for [[pattern key] group-aliases
                   :let [match? (re-find pattern name)]
                   :when match?]
               key)))
    str/lower-case)))

(def group-suggestions
  "Suggested asset tags, per group."
  #:group {:kitchen
           {
            ;; Coffee Maker
            "579aba41-6919-4790-9898-270a17a55574" "coffee-maker"
            ;; Refrigerator
            "579aba41-32a7-4898-8199-025ea716a741" "fridge"
            ;; Stove / Range
            "579aba41-663f-4a94-8e80-29499f7a82ae" "stove"
            ;; Dishwasher
            "579aba41-13af-49e5-a47e-7f3c4f15e43f" "dishwasher"
            ;; Blender
            "579aba44-ed9a-4660-b118-af009531676c" "blender"
            ;; Garbage Disposal
            "579aba41-285d-417f-9e4b-c5ef96fef07e" "garbage-disposal"
            }
           :laundry
           {;; Washing Machine (Washer)
            "583c99ea-6cc7-41df-b35c-7d425aa60a2d" "washer"
            ;; Clothes Dryer
            "583c99ea-686a-4066-9ca3-76c7affb73ed" "dryer"}
           :garage
           {
            ;; Vacuum Cleaner
            "579aba44-4ab6-4e4e-9f20-ee92010f18ad" "vacuum"
            ;; Sporting Goods
            "5859fdf2-b7a0-47d6-9120-bab45a1c182d" "sporting"
            ;; Bicycle
            "579aba68-2f0e-4703-9710-17cc598758b8" "bicycle"
            ;; Power Tools
            "579aba3e-fc50-4b28-9725-7380ae98290e" "power-tools"
            ;; Lawn Mower
            "579aba41-1e45-4c2a-ab88-e891fe71923b" "lawn-mower"
            }
           :living-room
           {
            ;; Ottoman
            "579aba65-9230-40f0-80c2-acb31718264b" "ottoman"
            ;; Sofa
            "579aba65-914f-4065-b830-945b8f05e104" "sofa"
            ;; Coffee Table
            "579aba63-656a-4e62-ad26-c6f97227168b" "coffee-table"
            ;; Recliner
            "579aba65-8046-4279-8ea1-8c8429331f5a" "recliner"
            }
           :office
           {
            ;; Computer
            "579aba41-2b97-463e-84a8-db23256c6fc6" "laptop"
            ;; Computer Monitor
            "579aba41-2936-4442-b2eb-740c6ca0c50b" "monitor"
            ;; Printer
            "579aba41-7a29-4837-a4c0-e669b51871a8" "printer"
            }
           :mechanical
           {
            ;; Furnace
            "579aba41-03bb-4601-aaba-87a236a665fe"  :group/everything-else
            ;; Water Heater
            "579aba41-f860-43e0-9762-596ef8e3b1e6" "water-heater"
            }
           :electronics
           {
            ;; Television
            "579aba41-cdee-4acf-9205-f5683e2e5d3b" "television"
            ;; Audio System
            "579aba47-af84-4ec6-b35c-bd67d821f1f8" "stereo"
            ;; Cell Phone
            "579aba41-c81b-42b6-8a05-b47f085c4669" "phone"
            ;; Camera
            "579aba41-b225-4cb3-b4d7-fa40c9213eae" "camera"
            }
           :building-finishes
           {
            ;; Paint
            "579aba44-8018-43d9-aa88-89f372dac36a" "paint"
            }
           :plants-trees
           {
            ;; Fruit Tree
            "579aba44-281f-4d70-bcb2-e0aad354af66" "fruit-tree"
            }
           :pool
           {
            ;; Pool Pump
            "579aba44-c262-406d-98be-760c654000cb" "pool-pump"
            ;; Pool Filter
            "579aba44-cd65-402a-9068-89d8b09e7b40" "pool-filter"
            }
           :personal-items
           {
            ;; Art
            "579aba61-52d7-4cda-ab53-66b6a4a0d216" "art"
            ;; Musical Instrument
            "579aba67-1f37-4ca9-bba3-1eac8de8237b" "musical-instruments"
            ;; Watch
            "579aba66-e0a8-4e1c-b211-d91a87fe2692" "watch"
            ;; Jewelry
            "579aba66-2d7f-40d3-bebf-72330714f543" "jewelry"
            }
           :everything-else
           {
            ;; Baby Monitor
            "579aba41-e06e-458b-925e-def876120a1a" "baby-monitor"
            ;; Stroller
            "579aba60-b42f-413f-b700-f67889393cb9" "stroller"
            }})

(def asset-tag->icon-name
  (apply merge (vals group-suggestions)))

(defn amazon-link->image [link]
  ;; link: https://www.amazon.com/dp/B0073YBHUI/?tag=cenapp-20
  ;; image: http://images.amazon.com/images/P/B001769IVI.01.SCLZZZZZZZ_.jpg

  ;; TODO
  ;; use the amazon api in the backend;
  ;; this url hack doesn't work for all images, but there's no way
  ;; to know beforehand, so this will sometimes return a blank image
  (when link
    (when-let [asin (second (re-find #"/dp/([^/]+).*" link))]
      (str
       "http://images.amazon.com/images/P/" asin ".01.SCLZZZZZZZ_.jpg"))))